import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { Contact } from '../../../providers/api/dtos/contact';
import { getContact } from '../../../providers/api/contact/contactProvider';

export const CONTACT_RID = '/api/v2/contacts';

export const getUseContactRid = (contactId: string) => [CONTACT_RID, contactId];

export default function useContact(contactId?: string, options?: SWRConfiguration): SWRResponse<Contact, Error> {
  return useSWR(contactId ? getUseContactRid(contactId) : null, () => getContact(contactId!), options);
}
